import { HttpServiceBase } from '../core/http-service-base';

import { Injectable } from '@angular/core';
import { EndingInputDataBase } from '../models/ending';
import { SupplierUrlEncryptionInputData } from '../models/supplier-url-encryption';
import { EndingOutputBase } from '../models/ending-output-base';

@Injectable({
  providedIn: 'root'
})
export class EndService extends HttpServiceBase {

  constructor() {
    super();
  }

  async setStatus(inputData: EndingInputDataBase, errorCallback?: (error: Error) => void): Promise<EndingOutputBase> {
    const self = this;
    const response: EndingOutputBase = await self.post<EndingInputDataBase, EndingOutputBase>('/end/set-status?rt=' + inputData.respondent.respondentToken, inputData, null, errorCallback);
    const output: EndingOutputBase = EndingOutputBase.createInstance(response);
    return output;
  }

  async generateSupplierURL(inputData: SupplierUrlEncryptionInputData, errorCallback?: (error: Error) => void): Promise<string> {
    const self = this;
    const outputData: string = await self.post<SupplierUrlEncryptionInputData, string>('/end/generate-supplier-url', inputData, null, errorCallback);
    return outputData;
  }
  // async generatePLSupplierURL(inputData: PLSupplierUrlEncryptionInputdata, errorCallback?: (error: Error) => void): Promise<String> {
  //   const self = this;
  //   const outputData: String = await self.post<PLSupplierUrlEncryptionInputdata, String>('/generate-plsupplier-url', inputData, null, errorCallback);
  //   return outputData;
  // }

  async ping(): Promise<string> {
    const self = this;
    return await self.get<any, string>('/sessions/ping');
  }
}
